import React from 'react';

import styles from './InvitationRequestReceived.module.scss';
import Button from '../../Shared/UI/Button/components/Button';

const InvitationRequestReceived = ({ closeInvitationRequestWizard }) => {
  return (
    <section id={styles.mainContent}>
      <div id={styles.messageContainer}>
        <p id={styles.message}>Thanks for your request. We'll be in touch with you about your invitation.</p>
      </div>
      <div>
        <Button
          onClick={() => {
            closeInvitationRequestWizard();
          }}
        >
          OK
        </Button>
      </div>
    </section>
  );
};

export default InvitationRequestReceived;
